export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/student-b057dfedf25127e6d3495fa64a896ce7.svg";